module.exports = __webpack_public_path__ + "img/close.921a49a8.png";